import {createComboUnitId} from './helpers';

export interface ComboUnitInterface {
    getUnitId(): string;
    getTeams(): string[];
    getQuantity(): number;
    isUsedInLineup(): boolean;
}

export class ComboUnit implements ComboUnitInterface {
    private readonly unitId: string = '';
    private constructor(
        private readonly teams: string[],
        private readonly quantity: number,
    ) {
        this.unitId = createComboUnitId(this.teams);
    }
    public getUnitId(): string {
        return this.unitId;
    }
    public getTeams(): string[] {
        return this.teams;
    }
    public getQuantity(): number {
        return this.quantity;
    }
    public isUsedInLineup(): boolean {
        return this.quantity > 0;
    }
    public static create(teams: string[], quantity: number): ComboUnitInterface {
        return new ComboUnit(teams, quantity);
    }
}
